import React, { Children } from 'react';
import Container from 'Nori/Container';
import styles from 'Custom/Split/SplitContent.module.scss';

const LEFT_SPLIT_SIDE = 0;
const RIGHT_SPLIT_SIDE = 1;

const SPLIT_VARIANTS = {
  questions: styles.questions,
  default: '',
};

const PADDING_VARIANTS = {
  no_padding: styles.no_padding,
  small_padding: styles.small_padding,
};

const MARGIN_VARIANTS = {
  no_margin: styles.no_margin,
};
const WIDTH_VARIANTS = {
  splitAutoWidth: styles.splitAuto,
};

const BG = {
  colored: styles.colored,
  transparent: styles.transparent,
};

const ALIGNMENT = {
  alignCenter: styles.alignCenter,
};

const SplitContent = ({
  alignContent = '',
  className = '',
  variant = 'default',
  reverse = false,
  children,
  backgroundColor,
  padding = '',
  splitAutoWidth = '',
  margin = '',
  ...props
}) => {
  const childrenArray = Children.toArray(children);
  const leftSide = childrenArray[LEFT_SPLIT_SIDE];
  const rightSide = childrenArray[RIGHT_SPLIT_SIDE];
  const directionClassName = reverse ? styles.ltr : styles.rtl;
  const variantClassName = SPLIT_VARIANTS[variant] || SPLIT_VARIANTS.default;
  const bgClassName = BG[backgroundColor] || BG.transparent;
  const paddingClassName = PADDING_VARIANTS[padding] || '';
  const marginClassName = MARGIN_VARIANTS[margin] || '';
  const splitAutoClassName = WIDTH_VARIANTS[splitAutoWidth] || '';

  return (
    <div
      className={`${styles.splitContentWrapper} ${bgClassName} ${directionClassName} ${variantClassName} ${className}`}
      {...props}
      data-qa-tag="split-content-wrapper"
    >
      <Container data-qa-tag="split-content-container">
        <div
          className={`${styles.splitRow}  ${paddingClassName} `}
          data-qa-tag="split-content-row"
        >
          {leftSide && (
            <div
              className={`${styles.splitLeft} ${marginClassName} ${splitAutoClassName}`}
              data-qa-tag="split-content-leftSide"
            >
              {leftSide}
            </div>
          )}
          {rightSide && (
            <div
              className={styles.splitRight}
              data-qa-tag="split-content-rightSide"
            >
              <div
                className={`${styles.splitRightContent} ${ALIGNMENT[alignContent]}`}
                data-qa-tag="split-content-rightSide-content"
              >
                {rightSide}
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default SplitContent;
